import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/app/search/[category]/error.tsx");
